var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-laptop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3166 18.4209C21.4324 18.4209 22.3453 17.5209 22.3453 16.4209V6.4209C22.3453 5.3209 21.4324 4.4209 20.3166 4.4209H4.08676C2.97096 4.4209 2.05803 5.3209 2.05803 6.4209V16.4209C2.05803 17.5209 2.97096 18.4209 4.08676 18.4209H1.04366C0.485761 18.4209 0.0292969 18.8709 0.0292969 19.4209C0.0292969 19.9709 0.485761 20.4209 1.04366 20.4209H23.3597C23.9176 20.4209 24.3741 19.9709 24.3741 19.4209C24.3741 18.8709 23.9176 18.4209 23.3597 18.4209H20.3166ZM5.10113 6.4209H19.3022C19.8601 6.4209 20.3166 6.8709 20.3166 7.4209V15.4209C20.3166 15.9709 19.8601 16.4209 19.3022 16.4209H5.10113C4.54322 16.4209 4.08676 15.9709 4.08676 15.4209V7.4209C4.08676 6.8709 4.54322 6.4209 5.10113 6.4209Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.fbda9a786221e432fd602aa038b2c677.svg";
export { ForwardRef as ReactComponent };